<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('course_assessment')" :isNewButton="checkPermission('course_index')"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                             :unchecked-value="true" v-model="column.hidden"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('course_assessment')"
                              @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                             :unchecked-value="true" v-model="column.hidden"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear" :exportExcel="checkPermission('courseagreement_excelexport')" @exportExcel="exportExcel" :otherButton="exportExcelData" @exportOtherExcel="exportOtherExcel">
                <b-row>
                        <b-col sm="6" md="4" lg="4" xl="3" >
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col sm="6" md="4" lg="4" xl="3">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="datatable.queryParams.filter.surname" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="4" xl="3">
                            <b-form-group :label="$t('student_number')">
                                <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="4" xl="3">
                            <b-form-group :label="$t('academic_year')">
                                <academic-years-selectbox v-model="datatable.queryParams.filter.academic_year"></academic-years-selectbox>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="4" xl="3">

                        <b-form-group :label="$t('faculty')">
                                <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code"
                                                />
                            </b-form-group>
                        </b-col>
                    <b-col sm="6" md="4" lg="4" xl="3">
                    <b-form-group :label="$t('program')">
                            <program-selectbox v-model="datatable.queryParams.filter.program_code"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="4" xl="3">
                        <b-form-group :label="$t('status')">

                        <parameter-selectbox v-model="datatable.queryParams.filter.status"
                                             code="course_agreement_statuses"
                        />
                        </b-form-group>
                    </b-col>


                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" @on-page-change="onPageChange"
                       @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"


import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import qs from 'qs'
import CourseAgreementFormHeadOfDepartmentServices from "@/services/StudentCourseAgreementServices";
import StudentCourseAgreementServices from "@/services/StudentCourseAgreementServices";
import CourseAgreementFormServices from "@/services/CourseAgreementFormServices";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,

    },
    metaInfo() {
        return {
            title: this.$t('course_program_outcomes')
        }
    },

    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "courseagreement_show",
                                show: function (row) {
                                    if(row.status == 'draft' || row.status == 'change_request') {
                                        return false
                                    }
                                    return true
                                },
                                callback: (row) => {
                                    this.$router.push('/student/course/agreement/'+row.id);
                                }
                            },
                            {
                                text: this.$t('download'),
                                class: 'ri-file-download-line align-middle mr-2 text-muted',
                                permission: "courseagreement_admindownloadagreementform",
                                show: (row)=> {
                                    return  row.status==='wdc_approved'
                                },
                                callback: (row) => {
                                    CourseAgreementFormServices.downloadForAdmin(row.student_program_id)
                                        .then(response => {
                                            this._downloadFile(response, 'course_agreement.pdf');
                                        })
                                        .catch(e => {
                                            this.showErrors(e,null,true)
                                        });
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-2-line',
                                permission: "courseagreement_delete",
                                callback: (row) => {
                                    this.deleteModal(() => {
                                        StudentCourseAgreementServices.del(row.id)
                                            .then(response => {
                                                this.$toast.success(this.$t('api.' + response.data.message));
                                                this.getRows();
                                            })
                                            .catch(error => {
                                                this.$toast.error(this.$t('api.' + error.data.message));
                                            });
                                    });
                                },
                            },
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false,
                    },

                    {
                        label: this.toUpperCase('academic_year'),
                        field: 'academic_year',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('faculty_name'),
                        field: this.getLocaleField('faculty_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('program_name'),
                        field: this.getLocaleField('program_name'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('registration_type'),
                        field: this.getLocaleField('registration_type'),
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('status'),
                        field: this.getLocaleField('status_name'),
                        hidden: false,
                    },


                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: '-id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {},
        }
    },
    computed: {
        exportExcelData() {
            return {
                title: this.$t('course'),
                show: this.checkPermission('courseagreement_coursecountreport'),
                emit: 'exportOtherExcel'
            }
        }
    },
    created() {
        this.filterSet();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {}
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            return CourseAgreementFormHeadOfDepartmentServices.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data
                    this.datatable.total = response.data.pagination.total
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        exportExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            return CourseAgreementFormHeadOfDepartmentServices.exportExcel(config)
                .then((response) => {
                    this._downloadFile(response, 'course_assessment.xlsx')
                })
                .catch(err => this.showErrors(err))
        },
        exportOtherExcel() {
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            return CourseAgreementFormHeadOfDepartmentServices.exportCourseCountExcel(config)
                .then((response) => {
                    this._downloadFile(response, 'course_agreement_student_count_report.xlsx')
                })
                .catch(err => this.showErrors(err))
        },


    }
}
</script>

